












































































































































import ModalBox from '@/modules/core/components/ModalBox.vue';
import { alertApi } from '../alert.api';
import { SocketIOService } from '@/socketio.service';
import BaseTable from '@/modules/core/components/BaseTable';
import { Prop, Component } from 'vue-property-decorator';
import { format } from 'date-fns';

import { triggerSequences } from '@shared/common/types/trigger-sequences';
import { Alert } from '../alert';

@Component({
  components: {
    ModalBox,
  },
})
export default class AlertsTable extends BaseTable {
  @Prop()
  public deviceId?: string;

  @Prop()
  public createdById?: string;

  public triggerSequences = [
    { id: undefined, label: '' },
    ...triggerSequences.sort((t1, t2) => t1.label.localeCompare(t2.label)),
  ];
  public lastNewAlertsReset = new Date();
  public newAlerts = 0;
  public format = format;

  public alertListener = async (): Promise<void> => {
    this.$buefy.snackbar.open({
      type: 'is-danger',
      message: 'Nouvelle alerte',
    });
    if (this.pagination.page === 1) {
      await this.getData();
      this.resetNewAlertsCount();
    } else {
      this.newAlerts++;
    }
  }

  public mounted(): void {
    this.getData();
    SocketIOService.sockets.backend.on('alert', this.alertListener);
  }

  public async fetchData(): Promise<any> {
    return await alertApi.findAll({
      ...this.pagination,
      ...this.filters,
      sort: this.sort,
    });
  }

  public beforeDestroy(): void {
    SocketIOService.sockets.backend.off('alert', this.alertListener);
  }

  public buildFilters(gridFilters: any): void {
    this.$super(BaseTable).buildFilters(gridFilters);

    if (this.deviceId) {
      this.filters.deviceId = this.deviceId;
    }

    if (this.createdById) {
      this.filters.createdById = this.createdById;
    }
  }

  public alertGmapsLink(alert: Alert): string {
    return `https://www.google.com/maps/search/?api=1&query=${[
      ...alert.gpsLocation.coordinates,
    ]
      .reverse()
      .join(',')}`;
  }

  public resetNewAlertsCount(): void {
    this.newAlerts = 0;
    this.lastNewAlertsReset = new Date();
    this.pagination.page = 1;
    this.getData();
  }

  public get exportUrl(): string {
    return alertApi.getExportUrl();
  }
}
